import {call, put} from 'redux-saga/effects'

import {
  GET_FACULTIES,
  GET_SEMESTERS,
} from '../actions/types'

import {
  FLEX_FACULTY,
} from '../config'

import api from '../api'


/* Triggered immediately after opening the app, saves the available faculties and
 * the available semesters, which are not dependent on anything */
export function* setInitialData (data) {
  if (data?.faculties.length) {
    // Appending the Flex modules "faculty" to the faculties list
    data.faculties.push(FLEX_FACULTY)
  }

  yield put({
    type: GET_FACULTIES,
    payload: data.faculties,
  })
  yield put({
    type: GET_SEMESTERS,
    payload: data.semesters,
  })
}

/* Gets all faculties and semesters on app open, then saves them in the state */
export function* getDataAsync () {
  try {
    const faculties = yield call(api.getFacultyData)
    const semesters = yield call(api.getSemesterData)
    const _data = {faculties, semesters}

    yield call(setInitialData, _data)
  } catch (err) {
    // Error 😔
    // TODO: Implement an error management system / corroborate with cache management
    // Adapt below to the new method of signaling errors!
    /*yield put({
      type: GET_DATA_ERROR,
      payload: err,
    })*/
  }
}
